// The projects to list issues from: searched in the user's Jira by key or name, or typed as
// keys when no token is chosen yet.
import { useState } from "react";

import { useT } from "../../../i18n";
import { ChipInput } from "../../../ui/ChipInput";
import { isProjectKey } from "../jql";
import { useJiraProjects } from "./useJira";

export function ProjectField({ credentialId, value, onChange }: { credentialId: string; value: string[]; onChange: (next: string[]) => void }) {
  const t = useT().tasks.create.jira;
  const [typed, setTyped] = useState("");
  const projects = useJiraProjects(credentialId, typed);
  const suggestions = (projects.data ?? []).map((p) => ({
    value: p.key,
    label: (
      <span className="flex items-baseline gap-2">
        <span className="font-mono text-[12px] font-semibold">{p.key}</span>{" "}
        <span className="truncate">{p.name}</span>
      </span>
    ),
  }));
  const status = credentialId === "" ? t.typeKeys : projects.isError ? t.lookupFailed(projects.error.message) : projects.isFetching ? t.searching : undefined;
  return (
    <ChipInput
      label={t.projects}
      values={value}
      onChange={onChange}
      suggestions={suggestions}
      onQuery={setTyped}
      placeholder={credentialId ? t.projectSearch : t.projectKeyPlaceholder}
      valid={(v) => isProjectKey(v)}
      removeLabel={t.remove}
      status={status}
    />
  );
}
